import Flex from "../../../../designComponents/Flex";
import Typography from "../../../../designComponents/Typography";
import { IBookingConfig } from "./types";

type Props = {
  bookingConfig: IBookingConfig;
};

const BookingConfigViewer = ({ bookingConfig }: Props) => {
  if (!bookingConfig) {
    return null;
  }
  return (
    <Flex direction="column" gap={"13px"}>
      <Flex>
        <Typography fontWeight="bold">Allow multiple Tenants :</Typography>
        <Typography>
          {bookingConfig.allowMultipleTenants ? "Yes" : "NO"}
        </Typography>
      </Flex>
      <Flex>
        <Typography fontWeight="bold">Group Create by:</Typography>
        <Typography>{bookingConfig.groupBy}</Typography>
      </Flex>
      <Flex>
        <Typography fontWeight="bold">
          Include all tenants on contract :
        </Typography>
        <Typography>
          {bookingConfig.includeAllTenantsInContract ? "Yes" : "NO"}
        </Typography>
      </Flex>
      <Flex>
        <Typography fontWeight="bold">
          Payment responsibility of lead only :
        </Typography>
        <Typography>{bookingConfig.leadPaysOnly ? "Yes" : "NO"}</Typography>
      </Flex>
    </Flex>
  );
};

export default BookingConfigViewer;
